<template lang="pug">
  .app_layout( :class="{ 'layout-with-banner': isShowGoogleMiniBanner }" )
    template( v-if="isShowGoogleMiniBanner" )
      BannerGoogleHomeMini( @hidePromoGHM="handleHidePromoGHM" )

    AppHeader

    .content( :class="{ 'main-page' : isMainPage, 'd-flex': isPurchasePage }" )
      router-view

    AppFooter(v-if="!isHideFooter")

</template>

<script>
// @ is an alias to /src
import AppHeader from "../components/AppHeader";
import AppFooter from "../components/AppFooter";
import BannerGoogleHomeMini from "../components/BannerGoogleHomeMini";

export default {
  name: "app",

  data() {
    return {
      isStartQuiz: false,
      isShowPromoGHM: false
    };
  },

  created: function() {
    window.addEventListener("resize", this.calc100vh);
    this.calc100vh();
  },

  beforeDestroy: function() {
    window.removeEventListener("resize", this.calc100vh);
  },

  computed: {
    isHideFooter() {
      return (
        this.$route.name === "500" ||
        this.$route.name === "404" ||
        this.$route.name === "messages" ||
        this.$route.name === "agent_profile_analytics" ||
        this.$route.name === "properties"
      );
    },

    isMobile() {
      return this.$mq === "md" || this.$mq === "sm" || this.$mq === "xs";
    },

    isMainPage() {
      return (
        (this.$route.name == "home" ||
          this.$route.name == "homeowners" ||
          this.$route.name == "agents") &&
        this.isMobile
      );
    },

    isShowGoogleMiniBanner() {
      return (
        this.$route.name == "home" && !this.isMobile && this.isShowPromoGHM
      );
    },

    isPurchasePage() {
      return this.$route.name == "lead";
    }
  },

  mounted: function() {
    let self = this;
    this.$root.$on("setStartQuiz", function(e) {
      self.isStartQuiz = e;
    });

    this.isShowPromoGHM =
      JSON.parse(localStorage.getItem("promoGHM")) != null
        ? JSON.parse(localStorage.getItem("promoGHM"))
        : true;
  },

  methods: {
    handleHidePromoGHM() {
      this.isShowPromoGHM = false;
    },

    calc100vh() {
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;

      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
  },

  components: {
    AppHeader,
    AppFooter,
    BannerGoogleHomeMini
  }
};
</script>

<style src="./style.scss" lang="scss"></style>
